import { Alert, Button, Form, Input, InputNumber } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import houseAdSizeApi from './HouseAdSizeApi';

const FormItem = Form.Item;

interface Props {

}

export const HouseAdSizeEdit: React.FC<Props> = () => {

    const [form] = useForm()

    const [error, setError] = useState()

    const history = useHistory()

    const { id } = useParams<{ id?: string }>()

    const handleSubmit = () => {
        form.validateFields().then(values => {
            houseAdSizeApi
                .edit(Number.parseInt(id ?? '-1'), { ...values })
                .then(history.goBack)
                .catch(err => {
                    setError(err.error)
                })
        })
    }

    useEffect(() => {
        houseAdSizeApi
            .view(Number.parseInt(id ?? '-1'))
            .then(itemResponseHouseAdSizeBeanObject => {
                const bean = itemResponseHouseAdSizeBeanObject.data
                if (!bean) {
                    return
                }
                form.setFieldsValue(bean)
            })
            .catch(err => {
                setError(err.error)
            })
    }, [])

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <FormItem
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input HouseAdSize name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip={'Name of the HouseAdSize'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="width"
                rules={[
                    {
                        required: true,
                        message: 'Please input Width'
                    },
                    {
                        type: 'integer',
                        min: 1,
                        max: 10000,
                        message: 'Please input a valid number',
                    }
                ]}
                label="Width"
                tooltip={'Width of House Ad Size'}
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
            <FormItem
                name="height"
                rules={[
                    {
                        required: true,
                        message: 'Please input Height'
                    },
                    {
                        type: 'integer',
                        min: 1,
                        max: 10000,
                        message: 'Please input a valid number',
                    }
                ]}
                label="Height"
                tooltip={'Height of House Ad Size'}
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit">Save</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Cancel</Button>
            </FormItem>
        </Form>
    )
}
